/* globals google */
'use strict';

import styles from './storeLocator/mapStyles';
import { applyRendering } from './util/render';
import StoreHours from './storeLocator/storeHours';

/**
 * Creates the HTML to show information about the store
 * @param {Object} store The store to show information about
 */
function createHTMLForInfoWindow (store) {
    var storeData = {
        latitude: store.latitude,
        longitude: store.longitude,
        URL: store.URL,
        name: store.name,
        address2: store.address2,
        postalCode: store.postalCode,
        city: store.city,
        stateCode: store.stateCode,
        distance: store.distance,
        phone: store.phone,
        hours: $('.js-store-hours .js-store-hours-current').html()
    };
    var infoWindowHtml = applyRendering('storeName', storeData);
    infoWindowHtml += applyRendering('storeHours', storeData);
    if (store.distance) {
        infoWindowHtml += applyRendering('storeDistance', storeData);
    }
    if (store.phone) {
        infoWindowHtml += applyRendering('storePhone', storeData);
    }
    return infoWindowHtml;
}

document.addEventListener('DOMContentLoaded', () => {
    StoreHours.run();

    const storeCoordinates = $('.js-store-details').data('store-coords').split(',');

    const latlng = new google.maps.LatLng(storeCoordinates[0], storeCoordinates[1]);
    const mapOptions = {
        scrollwheel: false,
        zoom: 20,
        center: latlng,
        streetViewControl: false,
        styles
    };

    let map = new google.maps.Map($('.js-map-canvas')[0], mapOptions);
    map.initialZoom = true;

    const markerUrl = {
        url: $('.js-map-canvas').data('marker-url'),
        labelOrigin: new google.maps.Point(8, 9)
    };

    const marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: markerUrl
    });

    var storeInformation = JSON.parse($('.js-map-canvas').attr('data-locations'));
    var infowindow = new google.maps.InfoWindow();

    var labelIndex = 0;
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    Object.keys(storeInformation).forEach(function (key) {
        var store = storeInformation[key];
        var storeLocation = new google.maps.LatLng(store.latitude, store.longitude);

        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');

        labelIndex++;

        var newMarker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: store.name,
            icon: markerUrl,
            label: { text: label, color: 'white', fontSize: '9px' }
        });

        newMarker.addListener('click', function () {
            infowindow.setOptions({
                content: createHTMLForInfoWindow(store)
            });
            infowindow.open(map, newMarker);
            $('body').trigger('analytics:clickonBlackMarker');
        });
    });

    $('.js-stores-image-carousel').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false
    });

    marker.addListener('click', function () {
        infowindow.setOptions({
            content: createHTMLForInfoWindow(storeInformation[0])
        });
        infowindow.open(map, marker);
    });

    infowindow.setOptions({
        content: createHTMLForInfoWindow(storeInformation[0])
    });
    infowindow.open(map, marker);

    $('body').on('click', '.js-scroll-to-map', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.js-map-canvas').offset().top - $('.js-mainHeader').height()
        }, 500);
    });
});
